/**
 * Active work-queue rows only — closed/completed/cancelled stay out of the queue list.
 */

const CLOSED_STATUSES = new Set(['completed', 'closed', 'cancelled']);

export function isClosedWorkQueueStatus(status) {
  const s = String(status || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
  return CLOSED_STATUSES.has(s);
}

/** Drop closed/completed/cancelled items from a list. */
export function excludeClosedWorkQueueItems(items) {
  if (!Array.isArray(items)) return [];
  return items.filter((item) => !isClosedWorkQueueStatus(item?.status));
}

/**
 * When listing the queue, hide closed items unless the caller explicitly asked for a closed status.
 */
export function applyActiveWorkQueueStatusFilter(items, statusFilter) {
  const requested = String(statusFilter || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
  if (requested && isClosedWorkQueueStatus(requested)) {
    return (items || []).filter(
      (item) => String(item?.status || '').toLowerCase().replace(/\s+/g, '_') === requested
    );
  }
  return excludeClosedWorkQueueItems(items);
}

/** UI lifecycle values used by the Status column (not Actions). */
export const QUEUE_LIFECYCLE_OPTIONS = [
  { value: 'open', label: 'Pending' },
  { value: 'working', label: 'Working' },
  { value: 'closed', label: 'Closed' },
];

/**
 * Map backend/queue status strings onto Pending / Working / Closed.
 * @returns {'open'|'working'|'closed'}
 */
export function normalizeQueueLifecycle(status) {
  const s = String(status || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
  if (['in_progress', 'working'].includes(s)) return 'working';
  if (['completed', 'closed', 'cancelled'].includes(s)) return 'closed';
  return 'open';
}
